import {filter, includes, isEmpty} from 'lodash';
import {useEffect,useState} from 'react';
import {useNavigate,useParams} from 'react-router-dom';
// material
import {
    Card,
    Table,
    Stack,
    TableRow,
    TableBody,
    TableCell,
    Container,
    Typography,
    TableContainer,
    TablePagination,
    TextField
} from '@mui/material';
// components
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import SearchNotFound from '../components/SearchNotFound';
import {UserListHead} from '../sections/@dashboard/user';
import axios from 'axios';
import {API_URL, LOAN_TYPE} from '../constant';
import moment from 'moment';
import { isMobile } from 'react-device-detect';
 
const TABLE_HEAD1 = [
    {id: 'loan_id',label: 'Loan Id'},
    {id: 'customer_name',label: 'Customer Name'},
    {id: 'type',label: 'Type'},
    {id: 'state',label: 'State'},
    // {id: 'kyc',label: 'KYC Status'},
    // {id: 'cibil',label: 'CIBIL'},
    {id: 'amount',label: 'Loan Amount'},
    {id: 'emi',label: 'EMI'},
    {id: 'tenure',label: 'Tenure'},
    {id: 'created_at',label: 'Created'}
];

function descendingComparator(a,b,orderBy) {
    if(b[orderBy] < a[orderBy]) {
        return -1;
    }
    if(b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order,orderBy) {
    return order === 'desc'
        ? (a,b) => descendingComparator(a,b,orderBy)
        : (a,b) => -descendingComparator(a,b,orderBy);
}

function applySortFilter(array,comparator,query) {
    const stabilizedThis = array?.map((el,index) => [el,index]);
    stabilizedThis?.sort((a,b) => {
        const order = comparator(a[0],b[0]);
        if(order !== 0) return order;
        return a[1] - b[1];
    });

    if(query) {
        if(isNaN(query)) {
            const filteringArray = array.filter(user => user?.loan !== null)
            return filter(filteringArray,(_user) => _user?.loan?.customer_name?.toLowerCase().indexOf(query.toLowerCase()) !== -1)
        }
        else {
            const filteringArray = array.filter(user => user?.loan_id !== null)
            return filter(filteringArray,(_user) => ((_user?.loan_id).toString()).toLowerCase().indexOf(query.toLowerCase()) !== -1)
        }
    }
    return stabilizedThis.map((el) => el[0]);
}

let filterValues = []

export default function LoanList() {
    const {state} = useParams()
    const [page,setPage] = useState(0);
    const [value,setValue] = useState([]);
    const [order,setOrder] = useState('asc');
    const [selected,setSelected] = useState([]);
    const [orderBy,setOrderBy] = useState('name');
    const [filterName,setFilterName] = useState('');
    const [rowsPerPage,setRowsPerPage] = useState(25);
    const [filteredValue,setFilteredValue] = useState([]);
    const navigate = useNavigate();
    const [loanState, setLoanState] = useState(LOAN_TYPE.DISBURSED_LOANS);
    
    const handleRequestSort = (event,property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        setSelected([]);
    };

    useEffect(() => {
        if (isMobile) {
            TABLE_HEAD1.length = 3;
        }
        fetchLoanData(state);
    }, [state, isMobile]);

    // Function to fetch loan data
    const fetchLoanData = async (currentState) => {
        let formattedState = currentState;
        if (currentState === LOAN_TYPE.DISBURSED_LOANS) {
            formattedState = "loan_disbursed";
        }
        try {
            const response = await axios.get(`${API_URL}/dealer_loans/${formattedState}`);
            if (response.data.status === "success") {
                const dealerLoans = response.data.data?.reverse();
                setValue(dealerLoans);
                setFilteredValue(dealerLoans);
            }
        } catch (error) {
            console.error("Error fetching loan data:", error);
        }
    };

    useEffect(() => {
        async function getLeadData(){
            if(!isEmpty(value)){
                const leadData= await axios.get(`${API_URL}/leads/${value[1]?.loan_id}`)
            }
        }
    getLeadData()
    }, [])
    
    const handleChangePage = (event,newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value,10));
        setPage(0);
    };

    const handleFilter = (e) => {
        const inpultValue = e.target.value
        const fieldName = e.target.name
        setPage(0)
        const filteringArray = value.filter(user => user?.loan_id !== null)
        filterValues = filteringArray.filter(loan =>{
            const filedValue = loan[fieldName]?.toString().toLowerCase() || ''
            return filedValue.match(new RegExp(inpultValue, 'i'))
        })
        setFilteredValue([...filterValues])
    };

    const emptyRows = page > 0 ? Math.max(0,(1 + page) * rowsPerPage - value.length) : 0; 
    const isUserNotFound = !isEmpty(value) && value.length === 0;

    const redirect= async (loanDetails)=>{
        const loanId = loanDetails?.loan_id
        navigate(`/dashboard/loan/${loanId}/details`, { state: { loanDetails } })
    }

    const handleChange = (event) => {
        const newState = event.target.value;
        setLoanState(newState); // Update local state
        fetchLoanData(newState); 
    };

    return (
        <Page>
            <Container>
                <Stack direction="row" alignItems="center" justifyContent="flex-start" mb={1} mt={1}>
                    <Typography variant="h4" gutterBottom>
                        {state ===LOAN_TYPE.DISBURSED_LOANS ? 'Disbursed Loans List' : 'Pending Loans List'}
                    </Typography>
                </Stack>
                
                <Card>
                    <Scrollbar>
                        <TableContainer sx={{width: 'auto'}}>
                            <Table>
                                <UserListHead
                                    order={order}
                                    orderBy={orderBy}
                                    headLabel={TABLE_HEAD1}
                                    rowCount={value.length}
                                    numSelected={selected.length}
                                    onRequestSort={handleRequestSort}
                                    onSelectAllClick={handleSelectAllClick}
                                />
                                <TableRow>
                                 <TableCell align="center" width={'150px'}><TextField type={'search'} variant='standard' name = 'loan_id' onChange={handleFilter} autoComplete='off' /></TableCell>
                                <TableCell align="center" width={'200px'}><TextField type={'search'} variant='standard' name='customer_name' onChange={handleFilter} autoComplete='off' /></TableCell>
                                <TableCell align="center" ><TextField type={'search'} variant='standard' name = 'type' onChange={handleFilter} autoComplete='off' /></TableCell>
                                <TableCell align="center" ><TextField type={'search'} variant='standard' name = 'state' onChange={handleFilter} autoComplete='off' /></TableCell>
                                <TableCell align='center' width={'150px'}></TableCell>
                                {/* <TableCell align='center'></TableCell>
                                <TableCell align='center'></TableCell> */}
                                <TableCell align='center' width={'150px'}></TableCell>
                                <TableCell align='center'></TableCell>
                                <TableCell align='center' width={'150px'}></TableCell>
                                </TableRow>
                                <TableBody>
                                    {filteredValue.slice(page * rowsPerPage,page * rowsPerPage + rowsPerPage).map((v,index) => { 
                                        return (
                                            <TableRow
                                                hover
                                                key={index}
                                            >
                                                <TableCell align="center" style={{cursor:'pointer',color:'blue'}} onClick={()=>redirect(v)}>{v?.loan_id}</TableCell>
                                                <TableCell align="center">{v?.customer_name}</TableCell>
                                                <TableCell align="center">{v?.type}</TableCell>
                                                {!isMobile && 
                                                <>
                                                    <TableCell align="center" padding='none'>{v?.state}</TableCell>
                                                    {/* <TableCell align="center" style={{color: v?.kyc_verified ? 'green' : 'orange'}}>{v?.kyc_verified ? 'verified' :'pending'}</TableCell>
                                                    <TableCell align="center" style={{color: v?.cibil_status ? 'green' : 'orange'}}>{v?.cibil_status ? 'done' :'pending'}</TableCell> */}
                                                    <TableCell align="center">{Number(v?.amount)}</TableCell>
                                                    <TableCell align="center">{Number(v?.disburse_emi)}</TableCell>
                                                    <TableCell align="center">{v?.disburse_tenure}</TableCell>
                                                    <TableCell align="center">{moment(v?.created_at).format('DD-MM-YYYY')}</TableCell>
                                                </>
                                                }
                                                
                                            </TableRow>
                                        );
                                    })}
                                    {emptyRows > 0 && (
                                        <TableRow style={{height: 53 * emptyRows}}>
                                            <TableCell colSpan={6} />
                                        </TableRow>
                                    )}
                                </TableBody>
                                {isUserNotFound && (
                                    <TableBody>
                                        <TableRow>
                                            <TableCell align="center" colSpan={6} sx={{py: 3}}>
                                                <SearchNotFound searchQuery={filterName} />
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                )}
                            </Table>
                        </TableContainer>
                    </Scrollbar>
                    <TablePagination
                        rowsPerPageOptions={[25,50,100,500]}
                        component="div"
                        count={value.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Card>
            </Container>
        </Page>
    );
}
